import { timeMeasurement } from '@pkg/utils';

export function convertMsToSec(milliseconds: number) {
    return milliseconds / timeMeasurement.msPerSec;
}

export function convertSecToMs(seconds: number) {
    return seconds * timeMeasurement.msPerSec;
}
